import { Container } from '../components/Container';
import { Footer } from '../components/Footer';
import { Header } from '../components/Header';
import { Seo } from '../components/Seo';
import { dataProtectionContent } from '../content';
import type { Locale } from '../content/types';
import { getSeoConfig } from '../lib/seo';

type DataProtectionPageProps = {
  locale: Locale;
};

export function DataProtectionPage({ locale }: DataProtectionPageProps) {
  const content = dataProtectionContent[locale];

  return (
    <>
      <Seo config={getSeoConfig('data-protection', locale)} />
      <Header locale={locale} />
      <main className="legal-page">
        <Container size="narrow">
          <p className="eyebrow">{locale === 'de' ? 'Datenschutz' : 'Privacy'}</p>
          <h1>{content.h1}</h1>
          {content.intro ? <p className="legal-page__intro">{content.intro}</p> : null}
          <div className="legal-page__sections">
            {content.sections.map((section, index) => {
              const headingId = `data-section-${index}`;

              return (
                <section key={section.title} aria-labelledby={headingId}>
                  <h2 id={headingId}>{section.title}</h2>
                  {section.paragraphs?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                  {section.contactBlock ? (
                    <address>
                      {section.contactBlock.map((line) => (
                        <span key={line}>{line}</span>
                      ))}
                    </address>
                  ) : null}
                  {section.list ? (
                    <ul>
                      {section.list.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  ) : null}
                </section>
              );
            })}
          </div>
        </Container>
      </main>
      <Footer locale={locale} />
    </>
  );
}
